import * as http from '@/model/http'
import { setHistory, setEntity, getCachedEntity } from '@/model/utils'
import { SpPageContentList } from '@/model/spPage/schema'
import { FetchOptions } from '@/model/types'

const cacheKey = 'watch-history'
let pendingRequest: Promise<SpPageContentList> | null = null

const fetch = async (args?: {
  options?: FetchOptions
}): Promise<SpPageContentList> => {
  const url = cacheKey
  const cached = getCachedEntity<SpPageContentList>(
    'SpContentList',
    url,
    args?.options
  )
  if (cached) return cached

  if (pendingRequest) return pendingRequest

  pendingRequest = (async () => {
    const { data }: { data: SpPageContentList } = await http.get(url)

    if (!args?.options?.disableCache) {
      setHistory(url, [cacheKey], args?.options)
      setEntity('SpContentList', data, cacheKey)
    }

    return data
  })()

  try {
    return await pendingRequest
  } finally {
    pendingRequest = null
  }
}

export default {
  fetch
}
